const env = "prod";

const Config = {
  prod: {
    apiEndpoint: "https://api.ginastee.com/api",
    wsEndpoint: "wss://api.ginastee.com/app/7d73d67e780a94f36a34t",

    auth: "https://auth.ginastee.com?redirect_uri=https://app.ginastee.com",
  },

  home: {
    apiEndpoint: "http://192.168.1.4:8000/api",
    //apiEndpoint: "https://api-test.ginastee.com/api",
    wsEndpoint: "ws://10.0.0.111:6001/app/ginastee-app-chat",

    auth: "https://auth-test.ginastee.com?redirect_uri=http://localhost:3000",
  },

  apiToken: getToken(),
};

function getToken() {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    if (!token) return false;
    return token;
  } catch (e) {
    return false;
  }
}

export default Config[env];

export const token = Config.apiToken;